import styled from 'styled-components';

export const DeveloperCardRoot = styled.div`
	display: grid;
	width: 100%;
	grid-gap: 25px;
	grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));

	@media (min-width: 1200px) {
		grid-template-columns: repeat(4, 1fr);
	}
`;

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;

export const PaginationWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 32px 0 20px;
`;
